import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "1f923fc7-9ec8-4c24-8477-1ec4362ad336",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the value of Sd (rounded to one decimal place):",
    suffixText: "cm<sup>2</sup>",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 109.4,
};
